export const CampaignSegment = {
  FacebookPaidSocial: 'facebook-paidsocial',
  Other: 'other',
} as const;

export type CampaignSegment = (typeof CampaignSegment)[keyof typeof CampaignSegment];

export const UTM_PARAM = {
  source: 'utm_source',
  medium: 'utm_medium',
} as const;

const FACEBOOK_SOURCE = 'facebook';
const PAID_SOCIAL_MEDIUM = 'paidsocial';

interface MatchInput {
  source: string | null;
  medium: string | null;
}

export const isCampaignSegment = (value: string | undefined): value is CampaignSegment =>
  Object.values(CampaignSegment).some((segment) => segment === value);

const normalise = (value: string | null): string => (value ?? '').trim().toLowerCase();

export const matchCampaignSegment = ({ source, medium }: MatchInput): CampaignSegment =>
  normalise(source) === FACEBOOK_SOURCE && normalise(medium) === PAID_SOCIAL_MEDIUM
    ? CampaignSegment.FacebookPaidSocial
    : CampaignSegment.Other;
